import { required } from 'labguard-cdk'

export const validateLogin = ({ username, password }) => ({
  username: required(username),
  password: required(password),
})
